/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react'

import { checkForOnlySpacesOrTags } from '../../../assets/ts/general/general'
import FileUpload from '../../../components/file-upload/file-upload'
import {
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  MAX_LENGTHS,
  SELECT_OPTION,
  SELECT_OPTION_STRING,
} from '../../../utils/constants/global-constants'
import CustomSelect from '../../../utils/controls/custom-select'
import InputText from '../../../utils/controls/input-text'
import RichTextEditor from '../../../utils/controls/rich-text-edit'

interface Category {
  Category: string
  CategoryCode: number
  Label: string
  OrgComponent: string
  ParentSectionCode?: number
  Value: number
}

const InquiryDetails = ({
  categories,
  fileError,
  files,
  filesProps,
  inputValidationObj,
  sections,
  setFileError,
  setFiles,
  setUserInputs,
  subcategories,
  tooltipObj,
  userInputs,
}) => {
  const [selectedCategory, setSelectedCategory] = useState({
    label: '',
    sectionCode: -1,
    value: -1,
  })
  const [replaceFile, setReplaceFile] = useState(false)

  const categoryOptions = [
    SELECT_OPTION,
    ...categories.map((category) => ({
      label: category.Category,
      sectionCode: category.ParentSectionCode,
      value: category.CategoryCode,
    })),
  ]

  const sectionOptions = [
    SELECT_OPTION,
    ...sections
      .filter(
        (sec) =>
          selectedCategory.value === ALL_SELECT_VALUE || sec.Value === selectedCategory.sectionCode
      )
      .map((s) => ({
        label: s.Section,
        value: s.SectionCode,
      })),
  ]

  const subCategoryOptions = [
    SELECT_OPTION,
    ...subcategories
      .filter(
        (sub) =>
          sub.ParentCategoryCode === selectedCategory.value ||
          sub.ParentCategoryCode === selectedCategory.sectionCode
      )
      .map((s) => ({
        label: s.Label,
        value: s.Value,
      })),
  ]

  const handleSubjectChange = (e: any) => {
    const { value } = e.target
    checkForOnlySpacesOrTags(value)
      ? setUserInputs({ ...userInputs, Subject: '' })
      : setUserInputs({ ...userInputs, [e.target.id]: e.target.value })
  }

  const handleCategoryChange = (e) => {
    const value = e.value
    const sectionCode = e.sectionCode
    setSelectedCategory(e)
    setUserInputs({
      ...userInputs,
      CategoryCode: value,
      SectionCode: sectionCode,
      SubCategoryCode: value,
    })
  }

  const handleSubcategoryChange = (e) => {
    setUserInputs({ ...userInputs, SubCategoryCode: e.value })
  }

  const handleSectionChange = (e) => {
    setUserInputs({ ...userInputs, SectionCode: e.value })
  }

  const handleChangeRichText = (e) => {
    setUserInputs((prev) => ({ ...prev, Description: e }))
  }

  useEffect(() => {
    setUserInputs({
      ...userInputs,
      SubCategoryCode: ALL_SELECT_VALUE,
    })
  }, [selectedCategory])

  return (
    <div className='row'>
      <div className='mb-1 col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2'>
        <InputText
          changeHandler={(e) => handleSubjectChange(e)}
          className='form-lg font-13 sourcesanspro'
          formClassName=' form-vertical'
          info={tooltipObj?.inquirySubject?.TooltipDescription}
          infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
          infoIcon='icon-info color-primary'
          inputProps={{
            className: 'font-12 poppins-medium title-color mb-1',
            id: 'Subject',
            maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY_FIVE,
            name: 'Subject',
            placeholder: 'Enter Subject',
            value: userInputs.Subject,
          }}
          isInfo
          isMandatory
          label='Subject'
          ref={inputValidationObj.Subject.link}
        />
      </div>
      <div className='mb-1 col-12 col-md-4 mt-2'>
        <CustomSelect
          className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
          formClassName='form-vertical'
          id='DashboardCategory'
          info={tooltipObj?.category?.TooltipDescription}
          infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
          infoIcon='icon-info color-primary'
          inputProps={{
            className: 'mb-1 font-12 poppins-medium title-color',
          }}
          isInfo
          isMandatory
          label='Category'
          name='Category'
          onChange={handleCategoryChange}
          options={categoryOptions}
          ref={inputValidationObj?.CategoryCode?.link}
          value={userInputs.CategoryCode}
        />{' '}
      </div>
      <div className='mb-1 col-12 col-md-4 mt-2'>
        <CustomSelect
          className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
          formClassName='form-vertical'
          id='Sub Category'
          info={tooltipObj?.subCategory?.TooltipDescription}
          infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
          infoIcon='icon-info color-primary'
          inputProps={{
            className: 'mb-1 font-12 poppins-medium title-color',
          }}
          isInfo
          label='Sub Category'
          name='Sub Category'
          onChange={handleSubcategoryChange}
          options={subCategoryOptions}
          value={userInputs.SubCategoryCode}
        />
      </div>
      <div className='mb-1 col-12 col-md-4 mt-2'>
        <CustomSelect
          className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
          disabled={true}
          formClassName='form-vertical text-wrap'
          id='Section'
          info={tooltipObj?.section?.TooltipDescription}
          infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
          infoIcon='icon-info color-primary'
          inputProps={{
            className: 'mb-1 font-12 poppins-medium title-color',
          }}
          isInfo
          label='Section'
          name='Section'
          onChange={handleSectionChange}
          options={sectionOptions}
          ref={inputValidationObj.SectionCode.link}
          value={userInputs.SectionCode}
        />
      </div>
      <div className='mb-1 col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2'>
        <RichTextEditor
          editorValue={userInputs.Description}
          formClassName='d-flex flex-column'
          info={tooltipObj?.inquiryDescription?.TooltipDescription}
          infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
          infoIcon='icon-info color-primary'
          inputProps={{
            className: 'font-12 poppins-medium title-color mb-1',
            id: ' Description ',
            name: ' Description',
            placeholder: 'Enter Description',
          }}
          isInfo
          isMandatory
          label='Description'
          maxCharLimit={800}
          ref={inputValidationObj?.Description?.link}
          sendValue={handleChangeRichText}
          setUserInputs={setUserInputs}
          userInputs={userInputs}
        />
        {/* <RichTextEditor
            defaultValue={undefined}
            editorValue={
              existingDueout && typeof dueoutInputs.Description === 'string'
                ? dueoutInputs.Description
                : dueoutInputs.Description === ''
                ? ''
                : null
            }
            formClassName='d-flex flex-column'
            info={tooltipObj.dueOutDescription?.TooltipDescription}
            infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: ' Description ',
              name: ' Description',
              placeholder: 'Enter Description',
            }}
            isInfo
            isMandatory
            label='Description'
            ref={validationFields.Description.link}
            sendValue={onChangeDescription}
            setUserInputs={setDueoutInputs}
          /> */}
      </div>
      <div className='mb-1 col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2'>
        <FileUpload
          error={fileError}
          fileError={fileError}
          filesProps={{ files, setFiles }}
          formClassName='d-flex flex-column'
          hint='Upload the files which are in the .png, .jpeg, .xlsx, .txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen'
          hintClassName='color-primary'
          info={tooltipObj?.inquiryAttachFile?.TooltipDescription}
          infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
          infoIcon='icon-info color-primary'
          inputProps={{
            className: 'font-12 poppins-medium title-color mb-1',
            id: 'Attach files ',
            name: ' Description',
          }}
          isInfo
          label='Attach file (s) '
          note='Screenshots need to be saved locally before uploading into system.'
          noteClassName='color-primary'
          replaceFileProps={{ replaceFile, setReplaceFile }}
          setFileError={setFileError}
        />
      </div>
    </div>
  )
}
export default InquiryDetails
